export class Evento {
  id: number;
  data: string;
  hora: string;
  descricao: string
}
